import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Tells the shell its (new) base URL after login/logout so it can persist it,
// re-fetch path configuration from that host, and rebuild the tab bar.
//
// Rendered by /hotwire_native/start after every native login (signedOut:
// false, baseUrl: the tenant root) and by the app-host entry page when signed
// out (signedOut: true) so the shell clears its persisted tenant base.
export default class extends BridgeComponent {
  static component = "session";
  static values = { baseUrl: String, signedOut: Boolean };

  connect() {
    super.connect();
    this.send("connect", {
      baseUrl: this.baseUrlValue,
      signedOut: this.signedOutValue,
    });
  }
}
